<template>
  <div id="app">
    <!-- 页面 -->
    <HeadComp :isChose="naveChose"></HeadComp>
    <transition name="page">
      <router-view ref="routerView"/>
    </transition>
    <FootComp v-show="footerShow"></FootComp>
  </div>
</template>

<script>
import HeadComp from "./components/Header";
import FootComp from "./components/Footer";
export default {
  name: "App",
  components: {
    HeadComp,
    FootComp,
  },
  data() {
    return {
      imgError: 'this.src="' + require("@/assets/img/no-img.png") + '"', //默认图片
      footerShow: false,
      naveChose: 0,
    };
  },
  methods:{
    scrollTo(domId,isAuto){
      if(this.$refs.routerView.scrollTo){
        this.$refs.routerView.scrollTo(domId,isAuto)
      }
    }
  }
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #fff;
  min-width: 1392px;
  /* padding-bottom: 400px;
    position: relative; */
  /* box-sizing: border-box; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue